export const MailIcon = () => {
  return (
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.3335 8.76953L11.8592 15.4375C12.6306 15.9775 13.0163 16.2475 13.4358 16.3521C13.8064 16.4444 14.194 16.4444 14.5645 16.3521C14.984 16.2475 15.3697 15.9775 16.1411 15.4376L25.6668 8.76953M7.9335 23.9362H20.0668C22.027 23.9362 23.0071 23.9362 23.7558 23.5547C24.4144 23.2192 24.9498 22.6837 25.2854 22.0252C25.6668 21.2765 25.6668 20.2964 25.6668 18.3362V10.8695C25.6668 8.90935 25.6668 7.92926 25.2854 7.18056C24.9498 6.522 24.4144 5.98657 23.7558 5.65101C23.0071 5.26953 22.027 5.26953 20.0668 5.26953H7.9335C5.97331 5.26953 4.99322 5.26953 4.24453 5.65101C3.58596 5.98657 3.05053 6.522 2.71497 7.18056C2.3335 7.92926 2.3335 8.90935 2.3335 10.8695V18.3362C2.3335 20.2964 2.3335 21.2765 2.71497 22.0252C3.05053 22.6837 3.58596 23.2192 4.24453 23.5547C4.99322 23.9362 5.97331 23.9362 7.9335 23.9362Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
